"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCenterPointFromRegion = exports.defaultInvalidGeocodingResultTypes = void 0;
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
exports.defaultInvalidGeocodingResultTypes = [
    'political',
    'country',
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5',
    'administrative_area_level_6',
    'administrative_area_level_7',
    'colloquial_area',
    'locality',
    'sublocality',
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality_level_3',
    'sublocality_level_4',
    'sublocality_level_5',
    'neighborhood',
    'route'
];
// Return the center point of Quebec
const getCenterPointFromRegion = ({ interview, regionPath }) => {
    return project_config_1.default.mapDefaultCenter;
};
exports.getCenterPointFromRegion = getCenterPointFromRegion;
